export const isEmpty = (objectValue) =>
  [Object, Array].includes((objectValue || {}).constructor) &&
  !Object.entries(objectValue || {}).length;
